import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DataTable from ".";
import { useTransactions } from "../../hooks/use-transaction";

export default function TransactionsTable() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search") || "");
  const [status, setStatus] = useState(searchParams.get("status") || "");

  const {data, loading, params, setParams} = useTransactions({
    search,
    status: status || undefined,
  });

  useEffect(() => {
    const next = new URLSearchParams(searchParams);
    if (search) next.set("search", search);
    else next.delete("search");
    if (status) next.set("status", status);
    else next.delete("status");
    setSearchParams(next, {replace: true});
    setParams((p) => ({...p, page: 1, search, status: status || undefined}));
  }, [search, status, searchParams, setParams, setSearchParams]);

  const columns = useMemo(
    () => [
      {header: "REFERENCE", accessorKey: "reference"},
      {header: "NAME", accessorKey: "name"},
      {header: "EMAIL", accessorKey: "email"},
      {header: "MEMBERSHIP", accessorKey: "membershipTitle"},
      {
        header: "AMOUNT",
        accessorKey: "amount",
        cell: ({getValue}) =>
          `₦${Number(getValue() || 0).toLocaleString("en-NG")}`,
      },
      {
        header: "STATUS",
        accessorKey: "status",
        cell: ({getValue}) => {
          const s = getValue();
          const cls =
            s === "SUCCESS"
              ? "bg-green-100 text-green-700"
              : s === "FAILED"
              ? "bg-red-100 text-red-700"
              : "bg-yellow-100 text-yellow-700";
          return (
            <span className={`px-2 py-1 rounded text-xs ${cls}`}>
              {String(s).toUpperCase()}
            </span>
          );
        },
      },
      {
        header: "DATE",
        accessorKey: "createdAt",
        cell: ({getValue}) => new Date(getValue()).toLocaleString(),
      },
      // {
      //   header: "ACTION",
      //   accessorKey: "action",
      //   cell: ({row}) => (
      //     <button
      //       className="uppercase bg-black text-white px-3 py-1 rounded-md text-xs"
      //       onClick={() => navigate(`/payments/${row.original._id}`)}
      //     >
      //       View
      //     </button>
      //   ),
      // },
    ],
    []
  );

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2 items-center">
        <input
          className="border rounded px-3 py-2 text-sm"
          placeholder="Search name/email/ref"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          className="border rounded px-3 py-2 text-sm"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">All statuses</option>
          <option value="INITIALIZED">Initialized</option>
          <option value="SUCCESS">Success</option>
          <option value="FAILED">Failed</option>
          {/* <option value="ABANDONED">Abandoned</option> */}
        </select>
      </div>

      <DataTable
        data={data.documents || []}
        columns={columns}
        globalFilter={search}
        setGlobalFilter={setSearch}
        pageSize={params.limit || 10}
        isLoading={loading}
        showSearchBar={false}
      />
    </div>
  );
}
